export default __webpack_public_path__ + "static/media/12.3ad163f6.png";